import { render, staticRenderFns } from "./BankRegisterForm.vue?vue&type=template&id=5e87224e&scoped=true&"
import script from "./BankRegisterForm.vue?vue&type=script&lang=js&"
export * from "./BankRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./BankRegisterForm.vue?vue&type=style&index=0&id=5e87224e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87224e",
  null
  
)

export default component.exports